<template>
  <div>
    <el-dialog
      title="修改密码"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
        size="mini"
      >
        <el-form-item label="新密码：" prop="newPassword">
          <el-input v-model="form.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="newPassword2">
          <el-input v-model="form.newPassword2"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()">修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      visible: true,
      form: {
        newPassword: "",
        newPassword2: "",
      },
      rules: {
        newPassword: [{ required: true, message: " ", trigger: "blur" }],
        newPassword2: [{ required: true, message: " ", trigger: "blur" }],
      },
    };
  },

  methods: {
    /**
     * 提交表单
     */
    async submit() {
      if (this.form.newPassword != this.form.newPassword2) {
        this.$message({
          message: "新密码和确认密码必须相同",
          type: "error",
        });
        return false;
      }

      if (this.form.newPassword.trim() == "") {
        this.$message({
          message: "请正确输入密码",
          type: "error",
        });
        return false;
      }

      let newPassword = this.form.newPassword;

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/account/changePassword`,
          {
            newPassword: newPassword,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        // 可能需要重新登录
        if (resData.code == 2004) {
          util.gotoLoginPage();
          return;
        }

        this.$message.error(resData.message);
        return;
      }

      // 关闭当前对话框
      this.visible = false;

      this.$message({
        message: "修改成功",
        type: "success",
      });
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>